/* Secret Scenta — adaptive video controller.
   Videos rendered by snippets/responsive-video.liquid carry data-ss-video (and,
   for Shopify-hosted clips, data-hls = HLS master + data-mp4 = fallback). Shopify
   only exposes ONE progressive mp4 (the source resolution, often 1080p); the
   smaller 720p/480p renditions live only inside HLS. So we stream HLS — natively
   on Safari/iOS, via a lazily-loaded hls.js everywhere else — capped to the
   player size, so a small on-page player pulls ~480p (~2-3 MB) instead of 17 MB.
   Playback is gated to the viewport: nothing downloads until a clip scrolls in. */
(() => {
  if (window.__ssHlsInit) return;
  window.__ssHlsInit = true;

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let libPromise = null;

  function loadLib(url) {
    if (window.Hls) return Promise.resolve();
    if (!url) return Promise.reject();
    if (!libPromise) {
      libPromise = new Promise((res, rej) => {
        const s = document.createElement('script');
        s.src = url; s.async = true; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    return libPromise;
  }

  // Attach a source once. Native HLS (Safari/iOS) plays the m3u8 directly and
  // picks its own bitrate; elsewhere hls.js streams it, capped to the player size.
  function attach(v) {
    if (v.__ssReady) return Promise.resolve();
    v.__ssReady = true;
    v.muted = true;
    const hls = v.getAttribute('data-hls');
    const mp4 = v.getAttribute('data-mp4');
    if (!hls) return Promise.resolve(); // already has a <source> (plain mp4 path)
    if (v.canPlayType('application/vnd.apple.mpegurl')) {
      v.src = hls;
      return Promise.resolve();
    }
    return loadLib(v.getAttribute('data-hls-lib')).then(() => {
      if (window.Hls && window.Hls.isSupported()) {
        const h = new window.Hls({ capLevelToPlayerSize: true, startLevel: -1, maxBufferLength: 15 });
        h.loadSource(hls); h.attachMedia(v);
      } else if (mp4) {
        v.src = mp4;
      }
    }).catch(() => { if (mp4) v.src = mp4; });
  }

  function play(v) { return attach(v).then(() => v.play().catch(() => {})); }
  // Exposed so a section's tap-to-unmute handler can start a not-yet-played clip.
  window.ssHlsPlay = play;

  function setup() {
    const vids = [].slice.call(document.querySelectorAll('video[data-ss-video]'));
    if (!vids.length || reduce) return; // reduced-motion: hold the poster frame
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) play(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach((v) => io.observe(v));
  }

  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();
